module.exports = "<app-topo></app-topo>\n<router-outlet></router-outlet>\n"